<template>
  <div class="chatParts_wrapper wrapper background">
    <div class="chatParts_inner">
      <div class="chatRoom_parts">
        <div class="heading-section wrapper hard">
          <h2 class="inner light">
            <span>{{ corner.name }}</span>
          </h2>
        </div>
        <div class="txt_area">
          <p>
            <RawHtml :text="corner.description" />
          </p>
        </div>
        <div class="chatRoom_partswrapper">
          <div class="chatRoom_partsInner">
            <ul
              class="videoContent_wrapper"
              :class="{three_column: corner.layout_pattern === layoutPattern.three_column}"
            >
              <li
                class="wrapper soft"
                v-for="room in $store.getters['room/getByCornerId'](corner.id)"
                :key="room.slug"
                :class="{videoContent_inner: !room.is_talked, roomList_wrapper: room.is_talked}"
              >
                <div
                  class="roomList_inner"
                  :class="{crowded: room.is_talked && !isAdmin && gteMaxJoinCount($route.params.hallSlug, room.slug, room.max_join_count)}"
                >
                  <Crowded v-if="room.is_talked && !isAdmin && gteMaxJoinCount($route.params.hallSlug, room.slug, room.max_join_count)" />
                  <router-link :to="switchRoomRoute(room)">
                    <div class="title_area flex_center">
                      <h4>
                        <fa-icon icon="comments" v-if="room.is_talked" />
                        <img src="/images/play_btn.png" alt="YoutubePlayButton" class="playBtn" v-else />
                        <span>{{ room.name }}</span>
                      </h4>
                      <PersonsCount
                        v-if="room.max_join_count && room.is_talked"
                        :hall-slug="$route.params.hallSlug"
                        :room-slug="room.slug"
                        :gte-max-join-count="gteMaxJoinCount($route.params.hallSlug, room.slug, room.max_join_count)"
                        :max-join-count="room.max_join_count"
                      />
                    </div>
                    <div v-if="room.thumbnail_url" class="video_parts">
                      <img :src="room.thumbnail_url" />
                    </div>
                    <div class="room_txt">
                      <p>
                        <RawHtml :text="room.description" />
                      </p>
                    </div>
                    <Participants
                      v-if="persons($route.params.hallSlug, room.slug).length"
                      :participants="persons($route.params.hallSlug, room.slug)"
                    />
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
          <!-- chatRoom_partsInner -->
        </div>
        <!-- /chatRoom_partswrapper -->
      </div>
      <!-- /chatRoom_parts -->
    </div>
    <!-- /chatParts_inner -->
  </div>
  <!-- /chatParts_wrapper -->
</template>

<script>
import Participants from "../elements/Participants"
import PersonsCount from "../elements/PersonsCount"
import RawHtml from "../elements/RawHtml"
import Crowded from "../elements/Crowded"

export default {
  name: "Corner",
  components: {PersonsCount, Participants, RawHtml, Crowded},
  data() {
    return {
      person: {},
      layoutPattern: {
        two_column: 1,
        three_column: 2
      }
    }
  },
  props: {
    hall: {
      type: Object,
      required: true
    },
    corner: {
      type: Object,
      required: true
    }
  },
  computed: {
    gteMaxJoinCount: vm => (hallSlug, roomSlug, maxJoinCount) => {
      if (maxJoinCount === null) return false

      return vm.$store.getters["participants/countByHallAndRoomSlug"](hallSlug, roomSlug) >= maxJoinCount
    },
    persons: vm => (hallSlug, roomSlug) => {
      return vm.$store.getters["participants/getByHallAndRoomSlug"](hallSlug, roomSlug)
    },
    isAdmin() {
      return this.$store.getters["auth/user"].type === 1
    }
  },
  methods: {
    switchRoomRoute: function(room) {
      if (!room.is_talked) return {name: "TRoom", params: {slug: this.$store.getters["event/slug"], hallSlug: this.hall.slug, roomSlug: room.slug}}

      if (room.has_entry) {
        return {name: "YRoomEntry", params: {slug: this.$store.getters["event/slug"], hallSlug: this.hall.slug, roomSlug: room.slug}}
      } else {
        return {name: "YRoom", params: {slug: this.$store.getters["event/slug"], hallSlug: this.hall.slug, roomSlug: room.slug}}
      }
    }
  }
}
</script>
